import React from "react";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Table,
  Switch,
  Button,
  Modal,
  Tooltip,
  message,
} from "antd";

import classes from "./DelegationLogs.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  delegationLogLockRequest,
  delegationLogUnlockRequest,
  delegationLogApproveRequest,
  getDelegationLogsRequest,
  getDelLogSitesRequest,
  getUsersLight,
  delegationLogDisableRequest,
  getDelegationLogPdf,
  delegationLogUpVersionRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { getDelegationLogAdminCreatePermission } from "../../reducers/user/selectors";
import AddDelegationLogForm from "./AddDelegationLogForm";
import EndOfStudyForm from "./EndOfStudyForm";
import DelegationPdfSnapshots from "./DelegationPdfSnapshots";
import TestTemplateForm from "./TestTemplateForm";

import { withNamespaces } from "react-i18next";
import { withParams } from "../../utils/url";

const routes = require("../../routes.json");

const { Content } = Layout;

class DelegationLogs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      delegationLogs: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      users: [],
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      sortedInfo: { columnKey: "order_index", order: "ascend" },
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      duplicateLogId: null,
      deleteLogId: null,
      versionUpId: null,
      deleteLogIdLoading: null,
      loadingPdf: [],
      loadingVersionUp: [],
      pdfSnapshotsId: null,
    };
  }

  async componentDidMount() {
    this.onNameSearch();
    this.getSites();
    this.getUsers();
  }

  getUsers = async () => {
    try {
      const { data: users } = await getUsersLight();
      this.setState({ users });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  getSites = async () => {
    try {
      const { data } = await getDelLogSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1,
      },
      this.getDelegationLogs
    );
  };

  getDelegationLogs = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getDelegationLogsRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });

      this.setState({
        delegationLogs: data.sort((a, b) => a.id - b.id),
        total: data.total_pages * per_page,
        currentPage: page,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        delegationLogs: null,
        errorMessage: JSON.stringify(get(e, "response.data.error", "Error")),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getDelegationLogs(pagination.current, pagination.pageSize)
    );
  };

  onDelegationLogEdit = (document) => () => {
    this.setState({ delegationLogEdit: document });
  };

  onDelegationLogEditHide = () => {
    this.setState({ delegationLogEdit: null });
  };

  onDelegationLogEditSubmit = () => {
    this.setState({ delegationLogEdit: null }, this.getDelegationLogs);
  };

  addDelegationLog = () => {
    this.setState({ delegationLogEdit: {} });
  };

  testTemplates = () => {
    this.setState({
      testTemplatesModalOpen: true,
    });
  };

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1 };
    }, this.getDelegationLogs);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getDelegationLogs);
  };

  onSwitchApprove = async (id) => {
    try {
      await delegationLogApproveRequest({ id });
      message.success(this.props.i18n.t("Saved"));
      this.getDelegationLogs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(JSON.stringify(get(e, "response.data.error", "Error")));
    }
  };

  onSwitchLock = (id, status) => async () => {
    try {
      if (["ready_to_be_signed", "qi_signed"].includes(status)) {
        await delegationLogLockRequest({ id });
      } else {
        await delegationLogUnlockRequest({ id });
      }

      message.success(this.props.i18n.t("Saved"));

      this.getDelegationLogs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  delegationLogDisable = async (id) => {
    this.setState({ deleteLogIdLoading: true });
    try {
      await delegationLogDisableRequest({ id });
      message.success(this.props.i18n.t("Saved"));
      this.getDelegationLogs();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
    this.setState({
      deleteLogId: null,
      deleteLogIdLoading: false,
    });
  };

  downloadReport = async (id) => {
    try {
      this.setState((state) => ({
        loadingPdf: { ...state.loadingPdf, [id]: true },
      }));

      let data = null;

      const response = await getDelegationLogPdf(id);
      data = response.data;

      const blob = new Blob([data], { type: "application/pdf" });
      // const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `delegation-log-${id}.pdf`;
      // link.target = '_blank';
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState((state) => ({
      loadingPdf: { ...state.loadingPdf, [id]: false },
    }));
  };

  versionUp = async (id) => {
    try {
      this.setState((state) => ({
        loadingVersionUp: { ...state.loadingVersionUp, [id]: true },
      }));

      await delegationLogUpVersionRequest({ id });
      message.success(this.props.i18n.t("Saved"));
      this.getDelegationLogs();
    } catch (e) {
      console.log(e);
      message.error("Error");
    }

    this.setState((state) => ({
      loadingVersionUp: { ...state.loadingVersionUp, [id]: false },
      versionUpId: null,
    }));
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      delegationLogs,
      sites,
      delegationLogEdit,
      sortedInfo,
      duplicateLogId,
      deleteLogId,
      deleteLogIdLoading,
      loadingVersionUp,
      versionUpId,
      pdfSnapshotsId,
    } = this.state;
    const { delegationLogAdminCreatePermission } = this.props;

    const columns = [
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("ID"),
        width: "60px",
        render: (val) => <span>{val}</span>,
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "site",
        key: "site",
        title: this.props.i18n.t("Site"),
        width: "150px",
        render: (val) =>
          get(val, "name") && (
            <span>
              {get(val, "code")} - {get(val, "name")}
            </span>
          ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "site" && sortedInfo.order,
      },
      {
        dataIndex: "major_version",
        key: "major_version",
        title: this.props.i18n.t("Version"),
        width: "120px",
        render: (val, row) => (
          <span>
            {val}
            {row.minor_version}
          </span>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "state",
        key: "state",
        title: this.props.i18n.t("Is active?"),
        width: "120px",
        render: (val) => (
          <span>
            {val === "active" && (
              <Icon type="check-square" className={classes.checkIcon} />
            )}
          </span>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("Status"),
        width: "120px",
        render: (val) => <span>{val.replace(/_/g, " ")}</span>,
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "id" && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "actions",
        title: this.props.i18n.t("Actions"),
        width: 450,
        render: (val, row) => (
          <div className={classes.actions}>
            <div>
              {row.editable && row.status !== "draft" && (
                <div>
                  <Tooltip placement="topLeft" title={this.props.i18n.t("Edit")}>
                    <a
                      href={withParams(routes.admin.delegationLog, { id: val })}
                    >
                      <Button size="small" style={{ margin: "0 5px 5px" }}>
                        {this.props.i18n.t("NamespaceDelegationLogs:Change minor version")}
                      </Button>
                    </a>
                  </Tooltip>
                </div>
              )}

              {row.status !== "draft" && (
                <div>
                  <Button
                    size="small"
                    style={{ margin: "0 5px 5px" }}
                    loading={loadingVersionUp[val]}
                    onClick={() => {
                      this.setState({
                        versionUpId: val,
                      });
                    }}
                  >
                    {this.props.i18n.t("NamespaceDelegationLogs:New major version")}
                  </Button>
                </div>
              )}

              {row.can_start_end_of_study && (
                <div>
                  <Button
                    size="small"
                    style={{ margin: "0 5px 5px" }}
                    onClick={() => {
                      this.setState({ delegationLogEndOfStudy: row });
                    }}
                  >
                    {this.props.i18n.t("NamespaceDelegationLogs:Start end of study")}
                  </Button>
                </div>
              )}

              {row.status !== "draft" && (
                <div>
                  <Button
                    size="small"
                    style={{ margin: "0 5px 5px" }}
                    onClick={() => {
                      this.setState({
                        duplicateLogId: val,
                      });
                    }}
                  >
                    {this.props.i18n.t("NamespaceDelegationLogs:Duplicate to other site")}
                  </Button>
                </div>
              )}
            </div>

            {row.status === "draft" && (
              <div style={{ marginLeft: "15px" }}>
                {this.props.i18n.t("Approve")}
                <br />
                <Tooltip
                  placement="topLeft"
                  title={this.props.i18n.t("Approve")}
                >
                  <Switch
                    className={classes.reactivateBtn}
                    checked={row.state === "draft"}
                    onChange={() => {
                      this.onSwitchApprove(val, row.state);
                    }}
                  />
                </Tooltip>
              </div>
            )}

            {["ready_to_be_signed", "qi_signed", "signing_locked"].includes(
              row.status
            ) && (
              <div style={{ marginLeft: "10px" }}>
                {row.status === "signing_locked"
                  ? this.props.i18n.t("Locked")
                  : this.props.i18n.t("Unlocked")}
                <br />
                <Tooltip
                  placement="topLeft"
                  title={
                    row.status !== "signing_locked"
                      ? this.props.i18n.t("Lock")
                      : this.props.i18n.t("Unlock")
                  }
                >
                  <Switch
                    className={classes.reactivateBtn}
                    checked={row.status !== "signing_locked"}
                    onChange={this.onSwitchLock(val, row.status)}
                  />
                </Tooltip>
              </div>
            )}

            <div className={classes.disableWrapper}>
              {row.editable && row.status === "draft" && (
                <Tooltip placement="topLeft" title={this.props.i18n.t("Edit")}>
                  <br />
                  <a href={withParams(routes.admin.delegationLog, { id: val })}>
                    <span>
                      <Icon
                        type="setting"
                        theme="filled"
                        className={classes.iconEdit}
                      />
                    </span>
                  </a>
                </Tooltip>
              )}

              <Button
                size="small"
                type="link"
                style={{ margin: "15px 10px 0 15px", width: "30px" }}
                onClick={() => this.downloadReport(val)}
                disabled={this.state.loadingPdf[val]}
                loading={this.state.loadingPdf[val]}
              >
                <span style={{ padding: "5px 2px 5px 0" }}>
                  <Icon type="file-pdf" style={{ fontSize: "18px" }} />
                </span>
                {/*PDF*/}
              </Button>

              <Button
                size="small"
                type="link"
                style={{ margin: "15px 10px 0 15px" }}
                onClick={() => {
                  this.setState({ pdfSnapshotsId: val });
                }}
              >
                <span style={{ padding: "5px 0" }}>
                  <Icon type="database" style={{ fontSize: "18px" }} />
                </span>
              </Button>

              <Tooltip placement="topLeft" title={this.props.i18n.t("Disable")}>
                <button
                  onClick={() => {
                    this.setState({
                      deleteLogId: val,
                    });
                  }}
                  className={classes.button}
                >
                  <span>
                    <br />
                    <Icon type="delete" className={classes.iconDelete} />
                  </span>
                </button>
              </Tooltip>
            </div>
          </div>
        ),
      },
    ];

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t(
                "NamespaceDelegationLogs:Delegation Log Admin"
              )}
            </h3>

            {/*<div className={classes.searchWrapper}>
                    <label className={classes.searchWrapperSearch}>
                      <b className={classes.searchWrapperLabel}>{this.props.i18n.t('SEARCH')}</b>
                      <Search
                        placeholder={this.props.i18n.t('By name')}
                        enterButton={this.props.i18n.t('Search')}
                        size="large"
                        onSearch={this.onNameSearch}
                        value={nameSearch}
                        onChange={this.onNameChange}
                        style={{ maxWidth: '500px'}}
                      />
                    </label>

                    <span className={classes.clearButton} onClick={this.clearFilters}>{this.props.i18n.t('Clear')}</span>
                  </div>*/}

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            {delegationLogAdminCreatePermission && (
              <div className={classes.settingsButtons}>
                <Button type="primary" onClick={this.addDelegationLog}>
                  {this.props.i18n.t("NamespaceDelegationLogs:Add new delegation log")}
                </Button>
                <Button type="ghost" size="small" onClick={this.testTemplates}>
                  {this.props.i18n.t("NamespaceDelegationLogs:Test templates")}
                </Button>
              </div>
            )}

            <div className={classes.tableWrapper}>
              <Table
                columns={columns}
                dataSource={delegationLogs}
                loading={isLoading}
                rowKey="id"
                onChange={this.handleTableChange}
                pagination={false}
                // pagination={{
                //   onShowSizeChange: (current, size) => {
                //     this.setState({ pageSize: size });
                //   },
                //   current: currentPage,
                //   total,
                //   pageSize,
                //   showSizeChanger: true,
                //   pageSizeOptions: ['10', '25', '50', '100']
                // }}
              />
            </div>

            <Modal
              visible={!!delegationLogEdit}
              onCancel={this.onDelegationLogEditHide}
              footer={null}
            >
              {delegationLogEdit && (
                <AddDelegationLogForm
                  sites={sites}
                  onSubmit={this.onDelegationLogEditSubmit}
                  onCancel={this.onDelegationLogEditHide}
                />
              )}
            </Modal>

            <Modal
              visible={!!duplicateLogId}
              onCancel={() => {
                this.setState({
                  duplicateLogId: null,
                });
              }}
              footer={null}
            >
              {duplicateLogId && (
                <AddDelegationLogForm
                  duplicateLogId={duplicateLogId}
                  sites={sites}
                  onSubmit={() => {
                    this.setState({
                      duplicateLogId: null,
                    });

                    this.getDelegationLogs();
                  }}
                  onCancel={() => {
                    this.setState({
                      duplicateLogId: null,
                    });
                  }}
                />
              )}
            </Modal>

            <Modal
              visible={!!this.state.delegationLogEndOfStudy}
              onCancel={() => {
                this.setState({
                  delegationLogEndOfStudy: null,
                });
              }}
              footer={null}
            >
              {this.state.delegationLogEndOfStudy && (
                <EndOfStudyForm
                  delegationLog={this.state.delegationLogEndOfStudy}
                  onSubmit={() => {
                    this.setState({
                      delegationLogEndOfStudy: null,
                    });

                    this.getDelegationLogs();
                  }}
                  onCancel={() => {
                    this.setState({
                      delegationLogEndOfStudy: null,
                    });
                  }}
                />
              )}
            </Modal>

            <Modal
              visible={!!deleteLogId}
              onCancel={() => {
                this.setState({
                  deleteLogId: null,
                });
              }}
              footer={null}
              width={360}
            >
              <div>
                <h6
                  className="headline-default"
                  style={{ textAlign: "center", margin: "0 0 20px" }}
                >
                  {this.props.i18n.t(
                    "NamespaceDelegationLogs:Are you sure you want to disable this delegation log?"
                  )}
                </h6>

                <div className={classes.actionsConfirm}>
                  <Button
                    type="secondary"
                    onClick={() => {
                      this.setState({
                        deleteLogId: null,
                      });
                    }}
                  >
                    {this.props.i18n.t("Cancel")}
                  </Button>
                  <Button
                    type="danger"
                    onClick={() => {
                      this.delegationLogDisable(deleteLogId);
                    }}
                    loading={deleteLogIdLoading}
                  >
                    {this.props.i18n.t("Delete")}
                  </Button>
                </div>
              </div>
            </Modal>

            <Modal
              visible={!!this.state.testTemplatesModalOpen}
              onCancel={() => {
                this.setState({
                  testTemplatesModalOpen: null,
                });
              }}
              footer={null}
            >
              {this.state.testTemplatesModalOpen && <TestTemplateForm
                onSubmit={() => {
                  this.setState({
                    testTemplatesModalOpen: null,
                  });
                }}
              />}
            </Modal>

            <Modal
              visible={!!pdfSnapshotsId}
              onCancel={() => {
                this.setState({
                  pdfSnapshotsId: null,
                });
              }}
              width={640}
              footer={null}
            >
              {pdfSnapshotsId && <DelegationPdfSnapshots id={pdfSnapshotsId} />}
            </Modal>
            <Modal
              visible={!!versionUpId}
              onCancel={() => {
                this.setState({
                  versionUpId: null,
                });
              }}
              footer={null}
              width={360}
            >
              <div>
                <h6
                  className="headline-default"
                  style={{ textAlign: "center", margin: "0 0 10px" }}
                >
                  {this.props.i18n.t(
                    "NamespaceDelegationLogs:Are you sure you want to increase the major version of this delegation log?"
                  )}
                </h6>

                <p style={{ textAlign: "center", margin: "0 0 20px" }}>
                  {this.props.i18n.t("NamespaceDelegationLogs:This will invalidate all the collected signatures and force staff members to resign.")}
                </p>

                <div className={classes.actionsConfirm}>
                  <Button
                    type="secondary"
                    onClick={() => {
                      this.setState({
                        versionUpId: null,
                      });
                    }}
                  >
                    {this.props.i18n.t("Cancel")}
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      this.versionUp(versionUpId);
                    }}
                    loading={loadingVersionUp[versionUpId]}
                  >
                    {this.props.i18n.t("NamespaceDelegationLogs:Version Up")}
                  </Button>
                </div>
              </div>
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  delegationLogAdminCreatePermission: getDelegationLogAdminCreatePermission(
    state
  ),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(DelegationLogs))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/DelegationLogs.js